/* Save vendor applications before the normal Shopify contact submission. */
(function () {
  if (window.__rvsVendorCatalogSave) return;
  window.__rvsVendorCatalogSave = true;
  var endpoint = 'https://mrbbtnbiyrborksiqzic.supabase.co/functions/v1/vendor-apply';
  window.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form || !form.elements || event.defaultPrevented || form.__rvsCatalogSaved) return;
    var fd = new FormData(form);
    var body = String(fd.get('contact[body]') || '');
    var formName = String(fd.get('contact[Form Name]') || '');
    if (!/Category:\s*Vendor Application/i.test(body) && !/bartender.*vendor|vendor.*bartender/i.test(formName)) return;
    event.preventDefault();
    if (form.__rvsCatalogSaving) return;
    form.__rvsCatalogSaving = true;
    var answers = {}, current = '';
    body.split(/\r?\n/).forEach(function (line) {
      var match = line.match(/^([^:]{1,160}):\s*(.*)$/);
      if (match) { current = match[1].trim(); answers[current] = match[2].trim(); }
      else if (current && line.trim()) answers[current] += '\n' + line.trim();
    });
    fd.forEach(function (value, name) {
      var match = /^contact\[(.+)\]$/.exec(name);
      if (match && !/^(body|Subject|Form Name)$/i.test(match[1]) && typeof value === 'string' && value.trim()) answers[match[1]] = value.trim();
    });
    var notice = form.querySelector('[data-rvs-catalog-error]');
    if (!notice) {
      notice = document.createElement('p'); notice.dataset.rvsCatalogError = '';
      notice.setAttribute('role', 'alert'); form.appendChild(notice);
    }
    notice.textContent = '';
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch(endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: fd.get('contact[email]'), name: fd.get('contact[name]'), phone: fd.get('contact[phone]') || fd.get('contact[Phone]'), answers: answers, source: formName || 'Vendor application' }),
        signal: controller.signal
      });
      var result = await response.json();
      if (!response.ok || !result.saved) throw new Error(result.reason === 'limit' ? 'limit' : 'save');
      form.__rvsCatalogSaved = true;
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      notice.textContent = error.message === 'limit'
        ? 'You have reached the application limit. Please try again later or contact submissions@redvelvetstudio.com.'
        : 'Your application could not be saved. Please try again. Your answers are still here.';
      form.querySelectorAll('[type="submit"]').forEach(function (button) {
        button.disabled = false;
        if (button.textContent.trim() === 'Submitting...') button.textContent = 'Submit Application';
      });
    } finally {
      clearTimeout(timer);
      form.__rvsCatalogSaving = false;
    }
  });
})();
